// Returns timestamp at beginning of current day
export default () => new Date().setUTCHours(0, 0, 0, 0)
